/**
 * TextsPanel component
 * @constructor app.editor.mediatabs.TextsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.common.panels", class TextsPanel extends fx.components.VBox 
{   
	constructor(model /*texts, book*/)
	{
		super(/*texts*/);

		this.model = model;
		this.data = model.texts;
		this._book = model.creation;
		//this._book = book;
	}
 

	get data()
	{
		return super.data;
	}

	/*set data(val)
	{
		super.data = val;

		if (this.grid)
			this.grid.data = val;
	}*/

	set data(val)
	{
		if (val instanceof fx.ModelArray)
			super.data = val;
		else
		if (val)
		{
			this.model = val;
			this.data = val.texts;
			this._book = val.creation;
		}

		if (this.grid && val)
			this.grid.data = val;
	}


	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
		if (this.initialized && this._book)
			this.data.loadRecommended( this._book.themeid );
	}

	set renderers(val)
	{
		if (this.grid)
			this.grid.renderers = val;
	}



	onReady()
	{
		super.onReady();

		this.grid.loading(true);

		this.data.loadRecommended( this.book.themeid );

		this.on("click", this.onTitleClick, this.addTitleButton);
		this.on("click", this.onTextClick, this.addTextbutton);

		this.on("loaded", this._onLoaded, this.data);
	}

	_onLoaded()
	{
		this.grid.loading(false);
	}

	create()
	{
		super.create();

		this.addTitleButton = new fx.components.Button({label : fx.text("Ajouter un titre"), className:"add-title"});
		this.addTextbutton = new fx.components.Button({label : fx.text("Ajouter du texte"), className:"add-text"});
		this.label = new fx.components.Text({text:fx.text("Modèles à personnaliser"), className:"label"});

		this.grid = new fx.components.VerticalGridDynamic( {	data : this.data,
																maxElementsPerRow : 2,
																tilesSameSize : true,
																maxRowHeight : 180,
																childEffect : "",
																renderers : { Text : shared.renderers.TextRenderer } } );
		
		this.addChild(this.addTitleButton, {width:"100%"});
		this.addChild(this.addTextbutton, {width:"100%"});
		this.addChild(this.label, {width:"100%", height:50});
		this.addChild(this.grid, {height:"fill", width:"100%"});		

	}

	onTitleClick()
	{
		this.book.event("add-component", {  
			component_type : "text",
			content: "title", 
			creation : "manual"
		} );
	}

	onTextClick()
	{
		this.book.event("add-component", {    
			component_type : "text",
			content: "text", 
			creation : "manual"
		} );
	}
	
	destroy() {
		super.destroy();

		this.grid = null;
	}

});